import { items } from "@/api/items/useItemQuery";
import { customFunctions } from "@/config/customFunction";
import { useModal } from "@/features/modal/ModalStackManager";
import customAlert from "@/features/ui/alert/alert";
import { ItemAutoComplete } from "@/features/ui/autoComplete/item/item-autoComplete";
import { DefaultInstance } from "@/instance/axios";
import { Box, Button, Flex, TextInput } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export function LotForm(params: {
  name?: string;
  itemCodeValue?: string;
  onSubmit?: (values: any) => void;
}) {
  const { t } = useTranslation();
  const { closeModal } = useModal();
  const { name, itemCodeValue, onSubmit } = params;
  const form = useForm({
    initialValues: {
      name: name,
      expiredAt: null,
      itemCode: itemCodeValue,
    },
  });

  const { data: itemData } = useQuery({
    ...items.codeSearch({
      query:
        form.values.itemCode || itemCodeValue
          ? { $and: [{ code: { $eq: form.values.itemCode || itemCodeValue } }] }
          : "",
    }),
    enabled: !!form.values.itemCode || !!itemCodeValue,
  });

  return (
    <Box maw={320} mx="auto" w={400} h={270}>
      <form
        onSubmit={form.onSubmit(async (values) => {
          try {
            let res = null;
            //  품목에 상관없이 lot 이름으로 중복 여부 확인
            if (customFunctions.ADD_LOT_NAME_ONLY_CHECK) {
              res = await DefaultInstance.lotsFindPost({
                search: values.name as string,
                searchFields: ["name"],
              });
            } else {
              res = await DefaultInstance.lotsFindPost({
                query: JSON.stringify({
                  $and: [{ name: { $eq: values.name } }, { itemCode: { $eq: values.itemCode } }],
                }),
              });
            }
            const isExist = res?.data?.length > 0;

            if (res.status === 200) {
              customAlert("로트가 생성되었습니다.", "로트 생성", "green");
              onSubmit && onSubmit(values);
              closeModal({});
              return;
            } else if (isExist) {
              customAlert(`${t("lot.duplicateName")}`, `${t("lot.name")}`, "red");
              return;
            }
          } catch (error) {
            console.error("로트 생성 실패", error);
          }
        })}
      >
        <Flex direction="column" gap="xs">
          <ItemAutoComplete
            label="품목코드"
            placeholder="품목코드"
            disabled
            withinPortal
            {...(form.getInputProps("itemCode") || itemCodeValue)}
          />
          <TextInput
            label="이름"
            placeholder="이름"
            {...form.getInputProps("name")}
            disabled={itemData?.data?.rows && itemData?.data?.rows[0]?.usesLotName ? false : true}
          />
          <DateInput
            label="만료일"
            placeholder="만료일"
            valueFormat="YYYY-MM-DD"
            locale="ko"
            popoverProps={{ withinPortal: true }}
            {...form.getInputProps("expiredAt")}
            disabled={
              itemData?.data?.rows && itemData?.data?.rows[0]?.usesLotExpiration ? false : true
            }
          />
          <Flex justify="end">
            <Button my={20} type="submit">
              생성
            </Button>
          </Flex>
        </Flex>
      </form>
    </Box>
  );
}
